(function () {
  class WinBatcherGroupedSymbols {
    constructor() {}

    isCellDuplicate(cells, cell) {
      for (let i = 0; i < cells.length; ++i) {
        if (cells[i].cell.reel === cell.reel && cells[i].cell.row === cell.row)
          return true;
      }
      return false;
    }

    batch(wins, canCelebrate) {
      let groupInfo = {};

      for (let i = 0; i < wins.winningLines.length; ++i) {
        let win = wins.winningLines[i];
        let symbolId = "" + win.symbol.value;
        if (!groupInfo.hasOwnProperty(symbolId)) {
          groupInfo[symbolId] = {};
        }

        let occurrences = "" + win.positions.length;

        if (!groupInfo[symbolId].hasOwnProperty(occurrences)) {
          groupInfo[symbolId][occurrences] = [];
        }

        groupInfo[symbolId][occurrences].push(i);
      }

      let res = [];
      for (let symbolId in groupInfo) {
        if (groupInfo.hasOwnProperty(symbolId)) {
          let symbolWinData = [];
          let symbolData = groupInfo[symbolId];

          let keys = Object.keys(symbolData);
          let totalSymbolWin = 0;

          for (let oak in symbolData) {
            if (symbolData.hasOwnProperty(oak)) {
              let winlines = symbolData[oak];
              for (let i = 0; i < winlines.length; ++i) {
                let sequence = {
                  winline: wins.winningLines[winlines[i]].winningLine,
                  winAmount: wins.winningLines[winlines[i]].winAmount,
                  direction: wins.winningLines[winlines[i]].direction,
                };

                res.push({
                  animationTypes: ["Winline", "Counter"],
                  data: [sequence],
                  counterData: sequence.winAmount,
                });

                if (canCelebrate) {
                  let win = wins.winningLines[winlines[i]];
                  totalSymbolWin += win.winAmount;
                  for (let j = 0; j < win.positions.length; ++j) {
                    if (this.isCellDuplicate(symbolWinData, win.positions[j]))
                      continue;
                    let winData = {
                      cell: win.positions[j],
                      symbolId: win.symbol.ids[j],
                      winId: win.symbol.value,
                      winline: i,
                    };
                    symbolWinData.push(winData);
                  }
                }
              }
            }
          }

          if (canCelebrate) {
            res.push({
              animationTypes: ["Symbol"],
              counterData: totalSymbolWin,
              data: symbolWinData,
            });
          }
        }
      }

      return res;
    }
  }

  let create = function () {
    return new WinBatcherGroupedSymbols();
  };
  resourceManager.registerSharedPlugin("WinBatcherGroupedSymbolsSW", create);
})();
